import { render, staticRenderFns } from "./EditLessonDeals.vue?vue&type=template&id=202509dc&scoped=true&"
import script from "./EditLessonDeals.vue?vue&type=script&lang=js&"
export * from "./EditLessonDeals.vue?vue&type=script&lang=js&"
import style0 from "./EditLessonDeals.vue?vue&type=style&index=0&id=202509dc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "202509dc",
  null
  
)

export default component.exports